import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { Form, Input, Checkbox } from "formik-antd";
import { Divider, Alert } from "antd";

import ModalForm from "../../../../../core/components/form/modalForm";

const ValidationSchema = Yup.object().shape({
    includeInThisInvoice: Yup.bool(),
    notes: Yup.string().required("Cannot be blank"),
});

const Formulario = (props) => {
    const _initialForm = () => {
        return {
            realAmount: "",
            includeInThisInvoice: true,
            notes: "",
        };
    };

    return (
        <ModalForm
            title="Rectification"
            initialValues={_initialForm()}
            onCancel={props.handleCancel}
            validationSchema={ValidationSchema}
            onSubmit={props.handleSubmit}
            visible={props.visible}
            width={600}
            render={({ setFieldValue, touched, errors, values }) => (
                <>
                    <Alert message="Continuing will cause the Job to be fully compensated with this invoice." banner />
                    <br />

                    <Form.Item label="Notes" name="notes" hasFeedback={true} showValidateSuccess={true}>
                        <Input name="notes" placeholder="Notes" />
                    </Form.Item>
                </>
            )}
        />
    );
};

export default Formulario;
